
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"25","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M24 13a12 12 0 10-22.322 6.12L12 13h12z","fill":"#5935DD"}}),_c('path',{attrs:{"d":"M1.608 19A12 12 0 0022.392 7L1.608 19z","fill":"#E345FF"}}),_c('path',{attrs:{"d":"M22.392 6.995a12 12 0 00-4.241-4.304C16.393 1.641 12-.5 6 2.5l6 10.495 10.392-6z","fill":"#4319DB"}})])
          )
        }
      }
    